<template>
  <div class="flex-1 cursor-auto inline">
    <icon-base
      :data-cy="'offer-shared-icon-' + icon"
      :icon="icon"
      :class="htmlClass"
      @click.stop="modelValue = !modelValue"
    />
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";

const modelValue = defineModel<boolean>();

const icon = computed(() =>
  modelValue.value ? "show-pass-no-bg" : "show-pass"
);
const htmlClass = computed(() =>
  modelValue.value ? "text-gray-500" : "text-disabled-medium"
);
</script>
